import { useSelector } from "react-redux";
import { Grid, makeStyles, Typography } from "@material-ui/core";

import { UNREALIZED_COLORS } from "../../constants";
import { currencyFormatter, getLabel } from "../../../../services";
import { ColorIndicator } from "../../../../components/colorIndicator";

const useStyles = makeStyles(() => ({
  boldText: {
    fontWeight: "bold",
  },
}));

export const HeaderLine = ({ value, title }) => {
  const classes = useStyles();
  const currencySymbol = useSelector((state) => state.auth.user.currency.symbol);

  return (
    <Grid container justifyContent="center">
      <Grid item xs={5}>
        <Typography className={classes.boldText} variant="body2">
          {title}
        </Typography>
      </Grid>
      <Grid item xs={2}>
        <Typography className={classes.boldText} variant="body2" align="right">
          {currencyFormatter(value, currencySymbol)}
        </Typography>
      </Grid>
    </Grid>
  );
};

export const LegendRows = ({ rows }) => {
  const currencySymbol = useSelector((state) => state.auth.user.currency.symbol);

  return (
    <>
      {rows.map((entry, index) => (
        <Grid key={index} container justifyContent="center">
          <Grid item xs={5}>
            <Grid container alignItems="center">
              <ColorIndicator color={UNREALIZED_COLORS[entry.key]} />
              <Typography variant="body2">{getLabel(entry.name)}</Typography>
            </Grid>
          </Grid>
          <Grid item xs={2}>
            <Typography variant="body2" align="right">
              {currencyFormatter(entry.value, currencySymbol)}
            </Typography>
          </Grid>
        </Grid>
      ))}
    </>
  );
};
